module.exports = __webpack_public_path__ + "img/trainings-2.c1aafb7d.png";